import { render, staticRenderFns } from "./ac1.vue?vue&type=template&id=24015a78&scoped=true&"
import script from "./ac1.vue?vue&type=script&lang=js&"
export * from "./ac1.vue?vue&type=script&lang=js&"
import style0 from "./ac1.vue?vue&type=style&index=0&id=24015a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24015a78",
  null
  
)

export default component.exports